<div
  class="border-default bg-surface text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus block h-auto w-full rounded-lg border p-2.5 text-sm">
  <ng-container class="w-full" #outlet></ng-container>
</div>
